/**
 * Created by Reda on 11.02.2026.
 */

AdventureExpedition.register_testadv = function () {
    Harvested.CONFIG.testadv = this.createExtendedHarvestedConfig();

    AchievementsConfig.registerExpedition("testadv", {
        fog: "fog1",
        force: Forces.LANDMARK_DONOR_SLOT1,
        donors: this.DONORS
    });

    CustomerRecipes.testadv = this.CUSTOMER_RECIPES;

    Spawner.PRIZES.testadv = this.SPAWNER_PRIZES;

    Map2d.TILE_MATERIALS.testadv = {};

    cleverapps.styles.testadv = {
        warehouseTutorialMinimal: this.WAREHOUSE_TUTORIAL_MINIMAL
    };
};
UnitsLibrary.CODES_BY_TAB.testadv = [
    [],
    [],
    [],
    ["advsource", "advgenerator0"],
    ["advprize", "expredchest"],
    []
];
